import React from "react";
import { Row, Button } from "reactstrap";

const PaginationCustom = ({
  pageIndex,
  totalPages,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  gotoPage,
}) => {
  
  const pageOptions = Array.from({ length: totalPages }, (_, i) => i);

  if (totalPages <= 1) {
  return null;
  }

  return (
    <Row className="align-items-center mt-3">
      <div className="d-flex align-items-center gap-2 justify-content-end">

        {/* PREVIOUS */}
        <Button
          style={{
            width: "27px",
            height: "27px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          disabled={!canPreviousPage}
          onClick={previousPage}
        >
          &laquo;
        </Button>

        {/* NUMBERS */}
        {(() => {
          const maxPages = 5;

          let start = Math.max(pageIndex - Math.floor(maxPages / 2), 0);
          let end = start + maxPages;

          if (end > totalPages) {
            end = totalPages;
            start = Math.max(end - maxPages, 0);
          }
          return pageOptions.slice(start, end).map((i) => (
            <Button
              key={i}
              onClick={() => gotoPage(i)}
              style={{
                backgroundColor: pageIndex === i ? "#396AFC" : "#F3F3F3",
                color: pageIndex === i ? "#FFFFFF" : "#000000",
                border: "1px solid #E3E3E3",
                fontWeight: 500,
                fontSize: "13px",
                width: "27px",
                height: "27px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {i + 1}
            </Button>
          ));
        })()}
        <Button
          style={{
            width: "27px",
            height: "27px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          disabled={!canNextPage}
          onClick={nextPage}
        >
          &raquo;
        </Button>

      </div>
    </Row>
  );
};

export default PaginationCustom;